import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { authenticate } from "../services/authorize";
import axios from 'axios'
import Swal from 'sweetalert2'

export default function Signin() {

  // const navigate = useNavigate()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleUsername = (e) => {
    setUsername(e.target.value);
  }

  const handlePassword = (e) => {
    setPassword(e.target.value);
  }

  const loginSubmit = (e) => {
    e.preventDefault()
    axios.post(`${process.env.REACT_APP_API}/user/login`, {username, password}, { withCredentials: true })
    .then(response => {
      if(response.data.error){
        Swal.fire({
          title: "error",
          text: response.data.error,
          icon: "error"
        });
      }else{
        //Login success
        authenticate(response, () => {
          // navigate to main page after login success
          // navigate('/dashboard/school-statistic')
          window.location.reload()
        })
      }
    }).catch(err => {
      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.response?.data ||
        err.message ||
        'เกิดข้อผิดพลาด กรุณาลองใหม่'
      Swal.fire({
        title: "เกิดข้อผิดพลาด",
        text: typeof msg === 'string' ? msg : JSON.stringify(msg),
        icon: "error"
      })
    })
  }

  return (
    <div className="page-sign">
      <Card className="card-sign">
        <Card.Header>
          <Link to="/" className="header-logo mb-4">SIS WTI</Link>
          <Card.Title>ลงชื่อเข้าใช้</Card.Title>
          <Card.Text>ยินดีต้อนรับ! กรุณาเข้าสู่ระบบเพื่อดำเนินการ</Card.Text>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={loginSubmit}>
            <div className="mb-4">
              <Form.Label >ชื่อผู้ใช้</Form.Label>
              <Form.Control type="text" value={username} onChange={handleUsername} placeholder="กรอกชื่อผู้ใช้" required />
            </div>
            <div className="mb-4">
              <Form.Label className="d-flex justify-content-between">รหัสผ่าน</Form.Label>
              <Form.Control type="password" value={password} onChange={handlePassword} placeholder="กรอกรหัสผ่าน" required />
              <Form.Label className="text-end w-100 mt-2"><Link to="">ลืมรหัสผ่าน?</Link></Form.Label>
            </div>
            <Button type="submit" variant="primary" className="btn-sign">เข้าสู่ระบบ</Button>

            {/* <div className="divider"><span>or sign in with</span></div>

            <Row className="gx-2">
              <Col><Button variant="" className="btn-facebook"><i className="ri-facebook-fill"></i> Facebook</Button></Col>
              <Col><Button variant="" className="btn-google"><i className="ri-google-fill"></i> Google</Button></Col>
            </Row> */}
          </Form>
        </Card.Body>
        <Card.Footer>
          ยังไม่บัญชีผู้ใช้? <Link to="/pages/signup">ติดต่อเจ้าหน้าที่</Link>
        </Card.Footer>
      </Card>
    </div>
  )
}